<div stop-propagation>
  <ng-container [ngSwitch]="hasSubscription">
    <!-- FOR USERS WITH SUBSCRIPTION -->
    <ng-container *ngSwitchCase="true" [ngSwitch]="showValidationWall">
      <div [popper]="tooltipcontent" popperTrigger="click" popperPlacement="left"
        popperApplyClass="!p-6x max-h-60 w-80 !pr-0 !box-content !mr-[10px] w-[332px]" popperAppendTo="app-root"
        [popperHideOnMouseLeave]="false" (popperOnShown)="onPopperShown()"  (popperOnHidden)="onPopperHidden()">
        <ng-container *ngTemplateOutlet="locationChangeTextTemplate"></ng-container>
      </div>

      <popper-content #tooltipcontent [ngSwitch]="showValidationWall">
        <ng-container *ngSwitchCase="true">
          <div class="popover-section">
            <div class="popover-section-header">
              <span class="product-invalid-icon"></span>
              <span class="popover-section-header-text ml10">
                {{ "components.product_locations_info.validation_wall.header_text" | translate }}
              </span>
            </div>

            <p class="popover-section-row mb-4 mt-3 font-text text-sm font-normal text-grey-100">
              {{
              "components.product_locations_info.validation_wall.text1"
              | translate: { retailerName: retailerName }
              }}
            </p>
            <p class="popover-section-row mb-4 font-text text-sm font-normal text-grey-100" [innerHTML]="
                'components.product_locations_info.validation_wall.text2' | translate
              "></p>

            <ng-container *ngIf="validationUrl">
              <ng-container *requiredModules="['SellerPimExtensions']">
                <lxm-button (click)="navigateToProductValidation()" type="beige" label="action.to_validate_product_card"
                  class="w-max">
                  <svg-icon svg-icon-left key="acceptMonochrome" fontSize="14px"></svg-icon>
                </lxm-button>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="false">
          <product-locations-popup [locations]="locations"></product-locations-popup>
        </ng-container>
      </popper-content>
    </ng-container>

    <!-- FOR USERS WITHOUT SUBSCRIPTION -->
    <ng-container *ngSwitchDefault>
      <div class="cursor-pointer text-xs font-medium text-grey-70 hover:underline" subscriptionRestricted>
        <ng-container *ngTemplateOutlet="locationChangeTextTemplate"></ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #locationChangeTextTemplate [ngSwitch]="showValidationWall">
  <ng-container *ngSwitchCase="true">
    <span class="cursor-pointer text-nowrap font-text text-xs font-medium text-grey-100 hover:underline [&.tooltip-open]:underline"
      [class.tooltip-open]="isTooltipOpen">
      {{'action.show_stores' | translate}}
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="false">
    <div class="flex items-center gap-2" *ngIf="locationCount >= 0 || locationDiff >= 0">
      <span class="cursor-pointer text-nowrap font-text text-xs font-medium text-grey-100 hover:underline [&.tooltip-open]:underline"
        [class.tooltip-open]="isTooltipOpen" [innerHTML]="
          'components.product_locations_info.popup.in_x_stores_short'
            | translate
              : {
                  count: locationCount
                }
        "></span>
      <ng-container *ngIf="getFormattedDiffSummaryPart(locationDiff) as diffSummary">
        <span class="flex product-location-diff" [ngClass]="'product-location-diff--' + diffSummary.diffClass" ngxTippy
          tippyClassName="tippy-white" [tippyProps]="{ content: diffSummary.tooltip }">
          {{ diffSummary.formattedDiff }}
        </span>
      </ng-container>
    </div>
  </ng-container>
</ng-template>